import React from "react";
import { Fragment } from "react";
import HomeIcon from "../assets/icons/dashboardNew.svg";
import { APP_ROUTES } from "../constants/appRoutes";
import {
  getComponentTexts,
  getFullRouteWithQueryString,
  objectHasKeysCheck,
} from "./commonMethods";

//Append name to the breadcrumb. EXAMPLE : Edit discount (Dicount name)
export const appendNameToBreadcrumbTitle = function (prefix, name) {
  return `${prefix} ${name ? `(${name})` : ""}`;
};

export const HomeTab = () => {
  return (
    <Fragment>
      {/* <img src={HomeIcon} alt="home" /> */}
      Dashboard
    </Fragment>
  );
};

// for product partner routes
const routesReplaceDashboardWithProductList = [
  APP_ROUTES.PRODUCT_CATALOG,
  APP_ROUTES.PRODUCT_VIEW,
  APP_ROUTES.PRODUCT_REQUESTED,
  APP_ROUTES.ADD_PRODUCT,
];

//Reference to component texts.
const purchaseOrderListTexts = getComponentTexts(
  "purchase_order_management.purchase_order_list"
);
const purchaseOrderAddTexts = getComponentTexts(
  "purchase_order_management.purchase_order_modify.purchase_order_add"
);
const purchaseOrderEditTexts = getComponentTexts(
  "purchase_order_management.purchase_order_modify.purchase_order_edit"
);
const supplierListTexts = getComponentTexts(
  "supplier_management.supplier_list"
);
const supplierReturnOverviewTexts = getComponentTexts(
  "supplier_management.supplier_return_overview"
);
const supplierAddTexts = getComponentTexts("supplier_management.supplier_add");
const supplierEditTexts = getComponentTexts(
  "supplier_management.supplier_edit"
);
const supplierViewTexts = getComponentTexts(
  "supplier_management.supplier_view"
);
const purchaseOrderViewTexts = getComponentTexts(
  "purchase_order_management.purchase_order_modify.purchase_order_manage_view"
);
const storeManagerListTexts = getComponentTexts(
  "store_manager_management.store_manager_list"
);
const storeManagerModifyTexts = getComponentTexts(
  "store_manager_management.store_manager_modify"
);
const storeManagerViewTexts = getComponentTexts(
  "store_manager_management.store_manager_view"
);
const vmTemplateListTexts = getComponentTexts(
  "vm_template_management.vm_template_list"
);

const vmTemplateModifyTexts = getComponentTexts(
  "vm_template_management.vm_template_modify"
);
const vmTemplateOverviewTexts = getComponentTexts(
  "vm_template_management.vm_template_overview"
);

const bulkRefillListTexts = getComponentTexts(
  "bulk_refill_management.bulk_refill_list"
);

const bulkRefillModifyTexts = getComponentTexts(
  "bulk_refill_management.bulk_refill_modify"
);

const bulkRefillOverviewTexts = getComponentTexts(
  "bulk_refill_management.bulk_refill_overview"
);

const vmSettingsListTexts = getComponentTexts(
  "vm_settings_management.vm_settings_list"
);

const vmSettingsModifyTexts = getComponentTexts(
  "vm_settings_management.vm_settings_modify"
);

const vmSettingsOverviewTexts = getComponentTexts(
  "vm_settings_management.vm_settings_overview"
);
const notificationTexts = getComponentTexts("notifications");

export const breadcrumbsMapping = (
  matchPath,
  options = {},
  visibleHomePage = true
) => {
  console.log("matchPath: ", matchPath);
  const breadcrumbsData = {
    // vending machine crud
    "/vm": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Machine List",
      },
    ],
    "/vm/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Machine List",
        url: "/vm",
      },
      {
        title: appendNameToBreadcrumbTitle("VM Overview", options.vmName),
      },
    ],
    "/deletedVm/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Machine List",
        url: "/vm",
      },
      {
        title: options.vmName,
      },
    ],
    [APP_ROUTES.CHANGE_PLANOGRAM_FOR_MULTIPLE_VMs]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Machine List",
        url: "/vm",
      },
      { title: "Change Planogram For Multiple VM" },
    ],
    [APP_ROUTES.DASHBOARD]: [],
    [APP_ROUTES.CREATE_VENDING_MACHINE]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Machine List",
        url: "/vm",
      },
      {
        title: "Create Vending Machine",
      },
    ],
    [APP_ROUTES.EDIT_VENDING_MACHINE]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Machine List",
        url: "/vm",
      },
      {
        title: options.vmName,
        url: `/vm/${options.vmId}`,
      },
      {
        title: "Edit",
      },
    ],
    [APP_ROUTES.LIST_REFILLS]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      // {
      //   title: "Vending Machine List",
      //   url: "/vm",
      // },
      {
        title:
          // appendNameToBreadcrumbTitle(
          "Refill List",
        //   options.vendingMachineName
        // ),
      },
    ],
    [APP_ROUTES.VIEW_TALLY_ORDER_OVERVIEW]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Refill List",
        url: APP_ROUTES.LIST_REFILLS,
      },
      {
        title: "Tally Order Overview",
        // appendNameToBreadcrumbTitle(
        //   "Add Refill",
        //   options.vendingMachineName
        // ),
      },
    ],
    [APP_ROUTES.VIEW_CASH_ORDER_OVERVIEW]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Refill List",
        url: APP_ROUTES.LIST_REFILLS,
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Cash Collected",
          options.cashOrderId
        ),
      },
    ],
    [APP_ROUTES.CREATE_KIT_TRANSFER]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Warehouse Orders",
        url: APP_ROUTES.WAREHOUSE_ORDER_LIST,
      },
      {
        title: "Add Kit Transfer",
      },
    ],
    [APP_ROUTES.CREATE_PACKAGE_TRANSFER]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Warehouse Orders",
        url: APP_ROUTES.WAREHOUSE_ORDER_LIST,
      },
      {
        title: "Add Package Transfer",
      },
    ],
    [APP_ROUTES.VIEW_REFILL_PLAN]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      // {
      //   title: "Vending Machine List",
      //   url: "/vm",
      // },
      {
        title: "Refill List",
        url: "/refills",
        // options.lastPageUrl,
      },
      {
        title: "VM Order Overview",
        // appendNameToBreadcrumbTitle(
        //   "Refill Overview",
        //   options.vendingMachineName
        // ),
      },
    ],

    [APP_ROUTES.VIEW_TOPUP_OVERVIEW]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Refill List",
        url: "/refills",
      },
      {
        title: "Top Up",
      },
    ],

    [APP_ROUTES.RETURN_ORDER_VIEW]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Vending Machine List",
        url: APP_ROUTES.LIST_VENDING_MACHINES,
      },
      {
        title: "Refill List",
        url: options.lastPageUrl,
      },

      {
        title: appendNameToBreadcrumbTitle(
          "View Return Order",
          options.OrderId
        ),
      },
    ],
    [APP_ROUTES.ADD_REFILL_PLAN]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Machine List",
        url: "/vm",
      },
      {
        title: "Refill List",
        url: options.lastPageUrl,
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Add Refill",
          options.vendingMachineName
        ),
      },
    ],
    [APP_ROUTES.EDIT_REFILL_PLAN]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Machine List",
        url: "/vm",
      },
      {
        title: "Refill List",
        url: options.lastPageUrl,
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Edit Refill",
          options.vendingMachineName
        ),
      },
    ],
    "/vm-snapshot/:vmId": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Machine List",
        url: "/vm",
      },
      {
        title: options.vmName,

        url: `/vm/${options.vmId}`,
      },
      {
        title: `Live stock`,
        // title: `Live stock (${options.vmName})`,
      },
    ],
    "/vm-feedback/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Machine List",
        url: "/vm",
      },
      {
        title: options.vmName,
        url: `/vm/${options.vmId}`,
      },
      {
        title: `${options.vmName} Feedbacks`,
      },
    ],
    // role crud
    "/roles": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Roles List",
      },
    ],
    "/role/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Roles List",
        url: "/roles",
      },
      {
        title: options.roleName,
      },
    ],
    "/add-role": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Roles List",
        url: "/roles",
      },
      {
        title: "Add Role",
      },
    ],
    "/edit-role/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Roles List",
        url: "/roles",
      },
      {
        title: objectHasKeysCheck(options) ? options.roleName : "Edit Role",
      },
    ],
    // user crud
    "/users": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Users List",
      },
    ],
    "/user/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Users List",
        url: "/users",
      },
      {
        title: appendNameToBreadcrumbTitle("User Overview", options.userName),
      },
    ],
    "/add-user": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Users List",
        url: "/users",
      },
      {
        title: "Add New User",
      },
    ],
    [APP_ROUTES.LINKED_NEW_WAREHOUSE_FOR_WM]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Users List",
        url: "/users",
      },
      {
        title: "Warehouse Manager Overview",

        url: `/wm/${options.warehouseManagerId}`,
      },
      {
        title: "Link New Warehouse",
      },
    ],
    [APP_ROUTES.EDIT_LINKED_WAREHOUSE_FOR_WM]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Users List",
        url: "/users",
      },
      {
        title: "Warehouse Manager Overview",

        url: `/wm/${options.warehouseManagerId}`,
      },
      {
        title: "Edit Linked Warehouse",
      },
    ],
    "/add-wm": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Users List",
        url: "/users",
      },
      {
        title: "Add New Warehouse Manager",
      },
    ],
    "/edit-wm:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Users List",
        url: "/users",
      },
      {
        title: "Edit Warehouse Manager",
      },
    ],
    "/wm:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Users List",
        url: "/users",
      },
      {
        title: "Warehouse Manager Overview",
      },
    ],
    "/sales-analytics": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Sales Analytics",
      },
    ],
    "/edit-user/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Users List",
        url: "/users",
      },
      {
        title: appendNameToBreadcrumbTitle("Edit User", options.userName),
      },
    ],
    // product crud
    "/products": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product List",
      },
    ],
    "/product/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product List",
        url: "/products",
      },
      {
        title: `Product Overview (${options.productName})`,
      },
    ],
    "/add-product": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product List",
        url: "/products",
      },
      {
        title: "Add New Product",
      },
    ],
    "/edit-product/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product List",
        url: "/products",
      },
      {
        title: `Edit Product (${options.productName})`,
      },
    ],
    "/product-feedback/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product List",
        url: "/products",
      },
      {
        title: objectHasKeysCheck(options)
          ? options.productName
          : "Product Feedback",
      },
    ],
    "/products-requested": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product List",
        url: "/products",
      },
      {
        title: "Products Requested",
      },
    ],
    "/add-request-product": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product List",
        url: "/products",
      },
      {
        title: "Add Request Product",
      },
    ],
    "/edit-request-product/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product List",
        url: "/products",
      },
      {
        title: "Edit Request Product",
      },
    ],
    "/request-product/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product List",
        url: "/products",
      },
      {
        title: "Request Product Overview",
      },
    ],
    "/sync-products": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product Catalog",
        url: "/products",
      },
      {
        title: "Sync Product List",
      },
    ],
    "/new-product-list": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product Catalog",
        url: "/products",
      },
      {
        title: "New Product List",
      },
    ],
    "/sync-products/:id": [
      {
        title: "Brands",
        url: "/sync-products",
      },
      {
        title: options.brandName || "Brand",
      },
    ],
    "/sync-products/:brandId/catalogue/:catalogueId": [
      {
        title: "Brands",
        url: "/sync-products",
      },
      {
        title: options.brandName || "Brand",
        url: options.brandId
          ? `/sync-products/${options.brandId}`
          : undefined,
      },
      {
        title: options.catalogueName || "Catalogue",
      },
    ],
    // product category crud
    "/product-categories": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product Catalog",
        url: "/products",
      },
      {
        title: "Product Category List",
      },
    ],
    "/product-category/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product Category List",
        url: "/product-categories",
      },
      {
        title: `Product Category Overview
 				(${options.productCategoryName})`,
      },
    ],
    // product brand crud
    "/product-brands": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product Catalog",
        url: "/products",
      },
      {
        title: "Product Brand List",
      },
    ],
    "/product-brand/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product Brand List",
        url: "/product-brands",
      },
      {
        title: `Product Brand Overview
				(${options.productBrandName})`,
      },
    ],
    // product unit crud
    "/product-units": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product Catalog",
        url: "/products",
      },
      {
        title: "Product Unit List",
      },
    ],
    "/product-unit/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product Unit List",
        url: "/product-units",
      },
      {
        title: `Product Unit Overview
				(${options.productUnitName})`,
      },
    ],
    // product packaging crud
    "/product-packagings": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product Catalog",
        url: "/products",
      },
      {
        title: "Product Packaging List",
      },
    ],
    "/product-packaging/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product Packaging List",
        url: "/product-packagings",
      },
      {
        title: `Product Packaging Overview
				(${options.productPackagingName})`,
      },
    ],
    // warehouse crud
    "/warehouses": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse List",
      },
    ],
    "/warehouse-orders": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse List",
        url: "/warehouses",
      },
      {
        title: "Warehouse Orders",
      },
    ],
    [APP_ROUTES.SALES_ORDER_VIEW]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse List",
        url: "/warehouses",
      },
      {
        title: "Warehouse Orders",
        url: "/warehouse-orders",
      },
      {
        title: "Sales Orders",
      },
    ],
    [APP_ROUTES.VIEW_CASH_COLLECTION]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse Orders",
        url: APP_ROUTES.WAREHOUSE_ORDER_LIST,
      },

      {
        title: "Cash In Hand",
      },
    ],

    [APP_ROUTES.VIEW_WAREHOUSE]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse List",
        url: "/warehouses",
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Warehouse Overview",
          options.warehouseName
        ),
      },
    ],
    [APP_ROUTES.LINKED_NEW_REFILL_PARTNER]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse List",
        url: "/warehouses",
      },
      {
        title: "Warehouse Overview",
        url: `/warehouse/${options.warehouseId}`,
      },
      {
        title: "Link New Refill Partner",
      },
    ],
    [APP_ROUTES.EDIT_LINKED_REFILL_PARTNER]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse List",
        url: "/warehouses",
      },
      {
        title: "Warehouse Overview",

        url: `/warehouse/${options.warehouseId}`,
      },
      {
        title: "Edit Linked Refill Partner",
      },
    ],
    [APP_ROUTES.LINKED_NEW_WAREHOUSE_MANAGER]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse List",
        url: "/warehouses",
      },
      {
        title: "Warehouse Overview",

        url: `/warehouse/${options.warehouseId}`,
      },
      {
        title: "Link New Warehouse Manager",
      },
    ],
    [APP_ROUTES.EDIT_LINKED_WAREHOUSE_MANAGER]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse List",
        url: "/warehouses",
      },
      {
        title: "Warehouse Overview",

        url: `/warehouse/${options.warehouseId}`,
      },
      {
        title: "Edit Linked Warehouse Manager",
      },
    ],
    [APP_ROUTES.WAREHOUSE_STOCK]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse List",
        url: "/warehouses",
      },
      {
        title: `Current Stock`,
      },
    ],
    [APP_ROUTES.TALLY_INVENTORY_ADD]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Tally Inventory",
          options.warehouseName
        ),
      },
    ],

    [APP_ROUTES.DISCARDED_BIN_OVERVIEW]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse Orders",
        url: "/warehouse-orders",
      },
      {
        title: "Discarded Bin Overview",
      },
    ],
    "/warehouse/:warehouseId/supplier-return-overview/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse Orders",
        url: "/warehouse-orders",
      },
      {
        title: "Supplier Return Overview",
      },
    ],
    "/warehouse/:id/warehouseStoreReturnOrders/:warehouseStoreReturnOrdersId": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse List",
        url: "/warehouses",
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Warehouse Overview",
          options.warehouseName
        ),
        url: `/warehouse/${options.warehouseId}`,
      },
      {
        // title: appendNameToBreadcrumbTitle(
        title: "Store Return Order OverView",
        //   options.warehouseReturnOrderId
        // ),
      },
    ],
    "/warehouse/:id/warehouseVMReturnOrders/:warehouseVMReturnOrdersId": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse List",
        url: "/warehouses",
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Warehouse Overview",
          options.warehouseName
        ),
        url: `/warehouse/${options.warehouseId}`,
      },
      {
        // title: appendNameToBreadcrumbTitle(
        title: "VM Return Order OverView",
        //   options.warehouseVMReturnOrderId
        // ),
      },
    ],
    "/add-warehouse": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse List",
        url: "/warehouses",
      },
      {
        title: "Add New Warehouse",
      },
    ],
    "/edit-warehouse/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse List",
        url: "/warehouses",
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Edit Warehouse",
          options.warehouseName
        ),
      },
    ],
    // inventory crud
    "/inventory": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Company Inventory",
      },
    ],
    "/warehouse-inventory/:warehouseId": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse List",
        url: "/warehouses",
      },
      {
        title: options.warehouseinventoryName,
      },
    ],
    // zone crud
    "/zones": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Zone List",
      },
    ],
    [APP_ROUTES.VIEW_ZONE]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Zone List",
        url: "/zones",
      },
      {
        title: options.zoneName,
      },
    ],
    "/add-zone": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Zone List",
        url: "/zones",
      },
      {
        title: "Add New Zone",
      },
    ],
    "/edit-zone/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Zone List",
        url: "/zones",
      },
      {
        title: appendNameToBreadcrumbTitle("Edit Zone", options.zoneName),
      },
    ],
    // delivery partner crud
    "/delivery-partners": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Delivery Partner List",
      },
    ],
    "/delivery-partner/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Delivery Partner List",
        url: "/delivery-partners",
      },
      {
        title: options.deliveryPartnerName,
      },
    ],
    "/add-delivery-partner": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Delivery Partner List",
        url: "/delivery-partners",
      },
      {
        title: "Add New Delivery Partner",
      },
    ],
    "/edit-delivery-partner/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Delivery Partner List",
        url: "/delivery-partners",
      },
      {
        title: objectHasKeysCheck(options)
          ? `Edit Delivery Partner ${options.deliveryPartnerName}`
          : "Edit Delivery Partner",
      },
    ],
    // Franchise crud
    "/franchises": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Franchise List",
      },
    ],
    "/add-franchise": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Franchise List",
        url: "/franchises",
      },
      {
        title: "Add New Franchise",
      },
    ],
    "/edit-franchise/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Franchise List",
        url: "/franchises",
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Edit Franchise",
          options.franchiseName
        ),
      },
    ],
    "/franchise/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Franchise List",
        url: "/franchises",
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Franchise Overview",
          options.franchiseName
        ),
      },
    ],
    // store crud
    "/stores": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Store List",
      },
    ],
    "/store-inventory/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Store List",
        url: "/stores",
      },
      {
        title: options.storeInventoryName,
      },
    ],
    "/franchise/:franchiseId/stores": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Franchises List",
        url: "/franchises",
      },
      {
        title: "Store List",
      },
    ],
    "/franchise/:franchiseId/add-store": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Franchises List",
        url: "/franchises",
      },
      {
        title: "Store List",
        url: `/franchise/${options.franchiseId}/stores`,
      },
      {
        title: "Add New Store",
      },
    ],
    "/franchise/:franchiseId/edit-store/:storeId": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Franchises List",
        url: "/franchises",
      },
      {
        title: "Store List",
        url: `/franchise/${options.franchiseId}/stores`,
      },
      {
        title: appendNameToBreadcrumbTitle("Edit Store", options.storeName),
      },
    ],
    "/franchise/:franchiseId/store/:storeId": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Franchises List",
        url: "/franchises",
      },
      {
        title: "Store List",
        url: `/franchise/${options.franchiseId}/stores`,
      },
      {
        title: appendNameToBreadcrumbTitle("Store Overview", options.storeName),
      },
    ],

    // store store return order overview page url
    "/franchise/:franchiseId/store/:storeId/storeStoreReturnOrderId/:storeStoreReturnOrderId":
      [
        {
          title: HomeTab(),
          url: "/dashboard",
        },
        {
          title: "Franchises List",
          url: "/franchises",
        },
        {
          title: "Store List",
          url: `/franchise/${options.franchiseId}/stores`,
        },
        {
          title: appendNameToBreadcrumbTitle(
            "Store Overview",
            options.storeName
          ),
          url: `/franchise/${options.franchiseId}/store/${options.storeId}`,
        },

        {
          // title: appendNameToBreadcrumbTitle(
          title: "Store Return Order OverView",
          // options.storeName
          // ),
        },
      ],

    "/franchise/:franchiseId/store/:storeId/storeVmReturnOrderId/:returnOrderId":
      [
        {
          title: HomeTab(),
          url: "/dashboard",
        },
        {
          title: "Franchises List",
          url: "/franchises",
        },
        {
          title: "Store List",
          url: `/franchise/${options.franchiseId}/stores`,
        },
        {
          title: appendNameToBreadcrumbTitle(
            "Store Overview",
            options.storeName
          ),
          url: `/franchise/${options.franchiseId}/store/${options.storeId}`,
        },
        {
          // title: appendNameToBreadcrumbTitle(
          title: "VM Return Order OverView",
          //   options.storeName
          // ),
        },
      ],

    //create store return order page
    "/franchise/:franchiseId/store/:storeId/create-store-return": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Franchises List",
        url: "/franchises",
      },
      {
        title: "Store List",
        url: `/franchise/${options.franchiseId}/stores`,
      },
      {
        title: "Store Overview",
        //  appendNameToBreadcrumbTitle("Store Overview", options.storeId),
        url: `/franchise/${options.franchiseId}/store/${options.storeId}`,
      },
      {
        title: "Create Store Return Order",
      },
    ],

    // shipping crud
    "/shippings": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Shipping Order List",
      },
    ],
    "/shipping/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Warehouse Order List",
        url: APP_ROUTES.WAREHOUSE_ORDER_LIST,
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Shipping Order Overview",
          options.shippingId
        ),
      },
    ],
    "/add-shipping": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Shipping Order List",
        url: "/shippings",
      },
      {
        title: "Create Shipping Order",
      },
    ],
    "/manage-shipping/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Shipping Order List",
        url: "/shippings",
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Manage Shipping Order",
          options.shippingId
        ),
      },
    ],
    // delivery person crud
    "/delivery-persons": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Delivery Person List",
      },
    ],
    "/delivery-person/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Delivery Person List",
        url: "/delivery-persons",
      },
      {
        title: options.deliveryPersonName,
      },
    ],
    "/add-delivery-person": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Delivery Person List",
        url: "/delivery-persons",
      },
      {
        title: "Add New Delivery Person",
      },
    ],
    "/edit-delivery-person/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Delivery Person List",
        url: "/delivery-persons",
      },
      {
        title: objectHasKeysCheck(options)
          ? `Edit Delivery Person ${options.deliveryPersonName}`
          : "Edit Delivery Person",
      },
    ],

    // refill partner crud
    "/refill-partners": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Refill Partner List",
      },
    ],
    "/refill-partner/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Refill Partner List",
        url: "/refill-partners",
      },
      {
        title: options.refillPartnerName,
      },
    ],
    "/add-refill-partner": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Refill Partner List",
        url: "/refill-partners",
      },
      {
        title: "Add New Refill Partner",
      },
    ],
    "/edit-refill-partner/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Refill Partner List",
        url: "/refill-partners",
      },
      {
        title: objectHasKeysCheck(options)
          ? `Edit Refill Partner ${options.refillPartnerName}`
          : "Edit Refill Partner",
      },
    ],
    [APP_ROUTES.LINKED_NEW_VM]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Refill Partner List",
        url: "/refill-partners",
      },
      {
        title: "Refill Partner Overview",
        url: `/refill-partner/${options.refillerId}`,
      },
      {
        title: "Link New Vending Machine",
      },
    ],
    [APP_ROUTES.EDIT_LINKED_VM]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Refill Partner List",
        url: "/refill-partners",
      },
      {
        title: "Refill Partner Overview",
        url: `/refill-partner/${options.refillerId}`,
      },
      {
        title: "Edit Link Vending Machine",
      },
    ],

    [APP_ROUTES.LINKED_NEW_WAREHOUSE]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Refill Partner List",
        url: "/refill-partners",
      },
      {
        title: "Refill Partner Overview",

        url: `/refill-partner/${options.refillerId}`,
      },
      {
        title: "Link New Warehouse",
      },
    ],

    [APP_ROUTES.EDIT_LINKED_WAREHOUSE]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Refill Partner List",
        url: "/refill-partners",
      },
      {
        title: "Refill Partner Overview",

        url: `/refill-partner/${options.refillerId}`,
      },
      {
        title: "Edit Link Warehouse",
      },
    ],

    [APP_ROUTES.LINKED_NEW_VEHICLE]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Refill Partner List",
        url: "/refill-partners",
      },
      {
        title: "Refill Partner Overview",

        url: `/refill-partner/${options.refillerId}`,
      },
      {
        title: "Link New Vehicle",
      },
    ],

    [APP_ROUTES.EDIT_LINKED_VEHICLE]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Refill Partner List",
        url: "/refill-partners",
      },
      {
        title: "Refill Partner Overview",

        url: `/refill-partner/${options.refillerId}`,
      },
      {
        title: "Edit Link Vehicle",
      },
    ],

    [APP_ROUTES.LINK_REFILL_PERMISSION]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Refill Partner List",
        url: "/refill-partners",
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Refill Partner Overview",
          options.refillerName
        ),
        url: `/refill-partner/${options.refillerId}`,
      },
      {
        title: "Add Permission",
      },
    ],
    [APP_ROUTES.EDIT_LINK_REFILL_PERMISSION]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Refill Partner List",
        url: "/refill-partners",
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Refill Partner Overview",
          options.refillerName
        ),
        url: `/refill-partner/${options.refillerId}`,
      },
      {
        title: "Edit Permission",
      },
    ],
    // purchase order crud
    "/orders": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Transaction History List",
      },
    ],
    "/order/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Transaction History List",
        // url: "/orders",
        url: options.paginationPath
          ? getFullRouteWithQueryString("/orders", options.paginationPath)
          : "/orders",
      },
      {
        title: options.orderId,
      },
    ],

    "/direct-sale": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Direct Sales",
      },
    ],

    [APP_ROUTES.CUSTOMER_FEEDBACK_LIST]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Customer Feedback List",
      },
    ],

    [APP_ROUTES.REQUEST_PRODUCTS_LIST]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Product List",
        url: "/products",
      },
      {
        title: "Products Requested",
      },
    ],

    "/coupon/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Coupons List",
        url: "/offerlist/coupons",
      },
      {
        title: options.couponName,
      },
    ],
    "/discount-view/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Campaigns",
        url: "/offerlist/discounts",
      },
      {
        title: options.discountName,
      },
    ],
    "/offerlist/discounts": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Campaigns",
      },
    ],
    "/offerlist/coupons": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Campaigns",
      },
    ],
    "/add-discount": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Campaigns",
        url: "/offerlist/discounts",
      },
      {
        title: "Add New Discount",
      },
    ],
    "/edit-discount/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Campaigns",
        url: "/offerlist/discounts",
      },
      {
        title: "Edit Offer Campaign",
      },
    ],
    [APP_ROUTES.CLONE_DISCOUNT]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Campaigns",
        url: "/offerlist/discounts",
      },
      {
        title: "Clone Offer Campaign",
      },
    ],
    [APP_ROUTES.RESTART_DISCOUNT]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Campaigns",
        url: "/offerlist/discounts",
      },
      {
        title: "Restart Offer Campaign",
      },
    ],
    "/add-coupon": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Coupon List",
        url: "/offerlist/coupons",
      },
      {
        title: "Add New Coupon",
      },
    ],
    "/edit-coupon/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Coupon List",
        url: "/offerlist/coupons",
      },
      {
        title: appendNameToBreadcrumbTitle("Edit Coupon", options.couponName),
      },
    ],

    [APP_ROUTES.VIEW_SUBOFFER_OVERVIEW]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Campaigns",
        url: "/offerlist/discounts",
      },
      {
        title: "Offer Overview",
        url: `/discount-view/${options.OfferViewId}`,
      },
      {
        title: "Suboffer Overview",
        url: [APP_ROUTES.VIEW_SUBOFFER_OVERVIEW],
      },

      {
        title: options.subOfferName,
      },
    ],

    //system auditor breadcrumb mapping

    [APP_ROUTES.MASTER_DATA_SETUP]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Master Data Setup",
      },
    ],

    [APP_ROUTES.NOTIFICATIONS]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: notificationTexts.notifications_title,
      },
    ],
    [APP_ROUTES.SUPPLIER_LIST]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      { title: supplierListTexts.page_title },
    ],
    [APP_ROUTES.SUPPLIER_RETURN_OVERVIEW]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      { title: supplierReturnOverviewTexts.page_title },
    ],
    [APP_ROUTES.MATERIAL_TRANSFER_OVERVIEW]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Warehouse Orders",
        url: APP_ROUTES.WAREHOUSE_ORDER_LIST,
      },
      { title: "Material Transfer Overview" },
    ],
    [APP_ROUTES.VIEW_TRANSFER_ORDER]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Warehouse Orders",
        url: APP_ROUTES.WAREHOUSE_ORDER_LIST,
      },
      { title: "Transfer Order Overview" },
    ],
    [APP_ROUTES.VIEW_REQUEST_ORDER]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Warehouse Orders",
        url: APP_ROUTES.WAREHOUSE_ORDER_LIST,
      },
      { title: "Request Order Overview" },
    ],
    [APP_ROUTES.VIEW_KIT_TRANSFER]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Warehouse Orders",
        url: APP_ROUTES.WAREHOUSE_ORDER_LIST,
      },
      { title: "Kit Transfer Overview" },
    ],
    [APP_ROUTES.VIEW_SALE_ORDER]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Warehouse Orders",
        url: APP_ROUTES.WAREHOUSE_ORDER_LIST,
      },
      { title: "Sale Order Overview" },
    ],
    [APP_ROUTES.VIEW_PACKAGE_TRANSFER]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Warehouse Orders",
        url: APP_ROUTES.WAREHOUSE_ORDER_LIST,
      },
      { title: "Package Transfer Overview" },
    ],
    [APP_ROUTES.TALLY_INVENTORY_OVERVIEW]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Warehouse Orders",
        url: APP_ROUTES.WAREHOUSE_ORDER_LIST,
      },
      { title: "Tally Inventory Overview" },
    ],
    [APP_ROUTES.SUPPLIER_ADD]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: supplierListTexts.page_title,
        url: APP_ROUTES.SUPPLIER_LIST,
      },
      { title: supplierAddTexts.page_title },
    ],
    [APP_ROUTES.SUPPLIER_EDIT]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: supplierListTexts.page_title,
        url: APP_ROUTES.SUPPLIER_LIST,
      },
      { title: supplierEditTexts.page_title },
    ],
    [APP_ROUTES.SUPPLIER_VIEW]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: supplierListTexts.page_title,
        url: APP_ROUTES.SUPPLIER_LIST,
      },
      {
        title: appendNameToBreadcrumbTitle(
          supplierViewTexts.page_title,
          options.supplierName
        ),
      },
    ],
    [APP_ROUTES.PURCHASE_ORDER_LIST]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Procurement Management",
      },
    ],
    [APP_ROUTES.PURCHASE_ORDER_ADD]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Procurement Management",
        url: APP_ROUTES.PURCHASE_ORDER_LIST,
      },
      {
        title: purchaseOrderAddTexts.page_title,
      },
    ],
    [APP_ROUTES.PURCHASE_ORDER_EDIT]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Procurement Management",
        url: APP_ROUTES.PURCHASE_ORDER_LIST,
      },
      {
        title: purchaseOrderEditTexts.page_title,
      },
    ],
    [APP_ROUTES.SAME_PURCHASE_ORDER]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Procurement Management",
        url: APP_ROUTES.PURCHASE_ORDER_LIST,
      },
      {
        title: purchaseOrderEditTexts.page_title,
      },
    ],
    [APP_ROUTES.PURCHASE_ORDER_VIEW]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Procurement Management",
        url: APP_ROUTES.PURCHASE_ORDER_LIST,
      },
      {
        title: purchaseOrderViewTexts.page_title,
      },
    ],
    [APP_ROUTES.PURCHASE_RETURN_VIEW]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Procurement Management",
        url: APP_ROUTES.PURCHASE_ORDER_LIST,
      },
      {
        title: "Purchase Return Overview",
      },
    ],
    [APP_ROUTES.PURCHASE_RETURN_EDIT]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Procurement Management",
        url: APP_ROUTES.PURCHASE_ORDER_LIST,
      },
      {
        title: "Edit Purchase Return",
      },
    ],
    [APP_ROUTES.PURCHASE_ORDER_RETURN]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Procurement Management",
        url: APP_ROUTES.PURCHASE_ORDER_LIST,
      },
      {
        title: "Create Purchase Return",
      },
    ],
    [APP_ROUTES.PURCHASE_RETURN_ADD]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Procurement Management",
        url: APP_ROUTES.PURCHASE_ORDER_LIST,
      },
      {
        title: "Create Purchase Return",
      },
    ],
    [APP_ROUTES.PURCHASE_ORDER_MANAGE]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Procurement Management",
        url: APP_ROUTES.PURCHASE_ORDER_LIST,
      },
      {
        title: purchaseOrderViewTexts.page_title,
      },
    ],
    [APP_ROUTES.STORE_MANAGER_LIST]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Store List",
        url: "/stores",
      },
    ],
    [APP_ROUTES.GENERATE_SHIPPING_ORDER_REQUEST]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Store List",
        url: "/stores",
      },
      {
        title: "Create Shipping Order Request",
      },
    ],
    [APP_ROUTES.STORE_MANAGER_ADD]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: storeManagerListTexts.page_title,
        url: APP_ROUTES.STORE_MANAGER_LIST,
      },
      { title: storeManagerModifyTexts.page_title },
    ],
    [APP_ROUTES.STORE_MANAGER_EDIT]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: storeManagerListTexts.page_title,
        url: APP_ROUTES.STORE_MANAGER_LIST,
      },
      { title: storeManagerModifyTexts.edit_page_title },
    ],
    [APP_ROUTES.STORE_MANAGER_VIEW]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: storeManagerListTexts.page_title,
        url: APP_ROUTES.STORE_MANAGER_LIST,
      },
      { title: storeManagerViewTexts.page_title },
    ],
    [APP_ROUTES.VM_TEMPLATE_LIST]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      { title: vmTemplateListTexts.page_title },
    ],
    [APP_ROUTES.VM_TEMPLATE_LIST_V2]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      { title: "Vending Machine Template List" },
    ],
    [APP_ROUTES.VM_TEMPLATE_ADD]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: vmTemplateListTexts.page_title,
        url: APP_ROUTES.VM_TEMPLATE_LIST,
      },
      { title: vmTemplateModifyTexts.create_page_title },
    ],
    [APP_ROUTES.VM_TEMPLATE_EDIT]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: vmTemplateListTexts.page_title,
        url: APP_ROUTES.VM_TEMPLATE_LIST,
      },
      { title: vmTemplateModifyTexts.edit_page_title },
    ],
    [APP_ROUTES.VM_TEMPLATE_CLONE]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: vmTemplateListTexts.page_title,
        url: APP_ROUTES.VM_TEMPLATE_LIST,
      },
      { title: vmTemplateModifyTexts.clone_page_title },
    ],
    [APP_ROUTES.VM_TEMPLATE_VIEW]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: vmTemplateListTexts.page_title,
        url: APP_ROUTES.VM_TEMPLATE_LIST,
      },
      { title: vmTemplateOverviewTexts.page_title },
    ],
    [APP_ROUTES.BULK_REFILL_LIST]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      { title: bulkRefillListTexts.page_title },
    ],
    [APP_ROUTES.BULK_REFILL_ADD]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: bulkRefillListTexts.page_title,
        url: APP_ROUTES.BULK_REFILL_LIST,
      },
      {
        title: bulkRefillModifyTexts.create_page_title,
      },
    ],
    [APP_ROUTES.BULK_REFILL_EDIT]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: bulkRefillListTexts.page_title,
        url: APP_ROUTES.BULK_REFILL_LIST,
      },
      {
        title: bulkRefillModifyTexts.edit_page_title,
      },
    ],
    [APP_ROUTES.BULK_REFILL_VIEW]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: bulkRefillListTexts.page_title,
        url: APP_ROUTES.BULK_REFILL_LIST,
      },
      {
        title: bulkRefillOverviewTexts.page_title,
      },
    ],
    [APP_ROUTES.VM_SETTINGS_LIST]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      { title: vmSettingsListTexts.page_title },
    ],
    [APP_ROUTES.VM_SETTINGS_ADD]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: vmSettingsListTexts.page_title,
        url: APP_ROUTES.VM_SETTINGS_LIST,
      },
      { title: vmSettingsModifyTexts.create_page_title },
    ],
    [APP_ROUTES.VM_SETTINGS_EDIT]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: vmSettingsListTexts.page_title,
        url: APP_ROUTES.VM_SETTINGS_LIST,
      },
      { title: vmSettingsModifyTexts.edit_page_title },
    ],
    [APP_ROUTES.VM_SETTINGS_CLONE]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: vmSettingsListTexts.page_title,
        url: APP_ROUTES.VM_SETTINGS_LIST,
      },
      { title: vmSettingsModifyTexts.clone_page_title },
    ],
    [APP_ROUTES.VM_SETTINGS_VIEW]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: vmSettingsListTexts.page_title,
        url: APP_ROUTES.VM_SETTINGS_LIST,
      },
      { title: vmSettingsOverviewTexts.page_title },
    ],
    [APP_ROUTES.PLANOGRAM_TEMPLATE_LIST]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Planogram Template List",
      },
    ],
    [APP_ROUTES.PLANOGRAM_TEMPLATE_ADD]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Planogram Template List",
        url: APP_ROUTES.PLANOGRAM_TEMPLATE_LIST,
      },
      {
        title: "Add Planogram Template ",
      },
    ],
    [APP_ROUTES.PLANOGRAM_TEMPLATE_EDIT]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Planogram Template List",
        url: APP_ROUTES.PLANOGRAM_TEMPLATE_LIST,
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Edit PLanogram Template",
          options.planogram_template_name
        ),
      },
    ],
    [APP_ROUTES.PLANOGRAM_TEMPLATE_CLONE]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Planogram Template List",
        url: APP_ROUTES.PLANOGRAM_TEMPLATE_LIST,
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Clone PLanogram Template",
          options.planogram_template_name
        ),
      },
    ],
    [APP_ROUTES.PLANOGRAM_TEMPLATE_VIEW]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Planogram Template List",
        url: APP_ROUTES.PLANOGRAM_TEMPLATE_LIST,
      },
      {
        title: appendNameToBreadcrumbTitle(
          "View PLanogram Template",
          options.zoneName
        ),
      },
    ],
    //report page
    [APP_ROUTES.REPORT]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Report",
      },
    ],
    //report page
    [APP_ROUTES.RETAILERS]: [
      {
        title: HomeTab(),
        url: APP_ROUTES.DASHBOARD,
      },
      {
        title: "Retailers",
      },
    ],
    [APP_ROUTES.ADVERTISEMENT_MANAGEMENT]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Advertisement List",
      },
    ],
    [APP_ROUTES.ADD_ADVERTISEMENT]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Advertisement List",
        url: APP_ROUTES.ADVERTISEMENT_MANAGEMENT,
      },
      ,
      {
        title: "Add Advertisement",
      },
    ],
    [APP_ROUTES.EDIT_ADVERTISEMENT]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Advertisement List",
        url: APP_ROUTES.ADVERTISEMENT_MANAGEMENT,
      },
      {
        title: options.advertisementName,
      },
    ],
    [APP_ROUTES.VIEW_ADVERTISEMENT]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Advertisement List",
        url: APP_ROUTES.ADVERTISEMENT_MANAGEMENT,
      },
      {
        title: options.advertisementName,
      },
    ],
    [APP_ROUTES.VM_ANALYTICS]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "VM Analytics",
      },
    ],
    [APP_ROUTES.THIRD_PARTY_SALES_LIST]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Customer Platform List",
      },
    ],
    [APP_ROUTES.PLATFORM_LINKED_VM_LIST]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Customer Platform List",
        url: APP_ROUTES.THIRD_PARTY_SALES_LIST,
      },
      {
        title: "Platform Linked VM List",
      },
    ],
    [APP_ROUTES.VM_RESTRICTED_PRODUCT_LIST]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Customer Platform List",
        url: APP_ROUTES.THIRD_PARTY_SALES_LIST,
      },
      {
        title: "Platform Linked VM List",
        url: `/platform-linked-vms/${options.customerPlatformId}`,
      },
      {
        title: "Restricted Product List",
      },
    ],
    [APP_ROUTES.NEGATIVE_ITEMS_LIST]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Negative Items List",
      },
    ],
    [APP_ROUTES.ADD_NEGATIVE_ITEM]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Negative Items List",
        url: APP_ROUTES.NEGATIVE_ITEMS_LIST,
      },
      {
        title: "Add Negative Item",
      },
    ],
    [APP_ROUTES.VIEW_NEGATIVE_ITEM]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Negative Items List",
        url: APP_ROUTES.NEGATIVE_ITEMS_LIST,
      },
      {
        title: options.negativeItemName,
      },
    ],
    [APP_ROUTES.LINKED_NEW_ITEM]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Negative Items List",
        url: APP_ROUTES.NEGATIVE_ITEMS_LIST,
      },
      {
        title: "Negative Item Overview",
        url: `/view-negative-item/${options.negativeItemId}`,
      },
      {
        title: "Link New Item",
      },
    ],
    [APP_ROUTES.EDIT_LINK_ITEM]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Negative Items List",
        url: APP_ROUTES.NEGATIVE_ITEMS_LIST,
      },
      {
        title: "Negative Item Overview",

        url: `/view-negative-item/${options.negativeItemId}`,
      },
      {
        title: "Link New Item",
      },
    ],
    [APP_ROUTES.LINKED_NEW_VM_NEGATIVE_ITEM]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Negative Items List",
        url: APP_ROUTES.NEGATIVE_ITEMS_LIST,
      },
      {
        title: "Negative Item Overview",

        url: `/view-negative-item/${options.negativeItemId}`,
      },
      {
        title: "Link New Vending Machine",
      },
    ],
    [APP_ROUTES.EDIT_LINK_VM_NEGATIVE_ITEM]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Negative Items List",
        url: APP_ROUTES.NEGATIVE_ITEMS_LIST,
      },
      {
        title: "Negative Item Overview",

        url: `/view-negative-item/${options.negativeItemId}`,
      },
      {
        title: "Edit Link Vending Machine",
      },
    ],

    "/pg-module": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "PG Module",
      },
    ],
    "/action-history": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Action History",
      },
    ],
    [APP_ROUTES.TECHNICIAN_LOGS]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Technician Logs",
      },
    ],
    [APP_ROUTES.TECHNICIAN_VM_LIST]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Machine List",
        url: APP_ROUTES.TECHNICIAN_VM_LIST,
      },
    ],
    [APP_ROUTES.MOTOR_ACTION_LOGS]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Motor Action Logs",
      },
    ],
    [APP_ROUTES.GET_JOB_LIST]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Jobs List",
      },
    ],
    [APP_ROUTES.VIEW_JOB]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Jobs List",
        url: APP_ROUTES.GET_JOB_LIST,
      },
      {
        title: appendNameToBreadcrumbTitle("Job Overview", options.job),
      },
    ],
    [APP_ROUTES.TECH_VM_TEMPLATE_LIST]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Template List",
      },
    ],
    [APP_ROUTES.TECH_VM_TEMPLATE_VIEW]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Template List",
        url: APP_ROUTES.TECH_VM_TEMPLATE_LIST,
      },
      {
        title: appendNameToBreadcrumbTitle("VM Template Overview", options.vm),
      },
    ],
    "/tech-edit-vm-template/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Template List",
        url: APP_ROUTES.TECH_VM_TEMPLATE_LIST,
      },
      {
        title: appendNameToBreadcrumbTitle("Edit VM Template", options.vm),
      },
    ],

      "/tech-add-vm-template": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Template List",
        url: APP_ROUTES.TECH_VM_TEMPLATE_LIST,
      },
      {
        title: "Add VM Template",
      },
    ],

    "/tech-clone-vm-template/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Template List",
        url: APP_ROUTES.TECH_VM_TEMPLATE_LIST,
      },
      {
        title: appendNameToBreadcrumbTitle("Clone VM Template", options.vm),
      },
    ],

    [APP_ROUTES.TECHNICIAN_PARTNER_LIST]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Technician Partner List",
      },
    ],
    [APP_ROUTES.TECHNICIAN_PARTNER_ADD]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Technician Partner List",
        url: APP_ROUTES.TECHNICIAN_PARTNER_LIST,
      },
      {
        title: "Add Technician Partner",
      },
    ],
    "/incident-list": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Incident List",
      },
    ],
    "/add-incident": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Incident List",
        url: APP_ROUTES.GET_INCIDENT_LIST,
      },
      {
        title: "Report Incident",
      },
    ],
    [APP_ROUTES.INCIDENT_TYPE_ADD]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Add Incident Type",
      },
    ],
    [APP_ROUTES.ADD_JOB]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Jobs List",
        url: APP_ROUTES.GET_JOB_LIST,
      },
      {
        title: "Add Job",
      },
    ],
    "/tech-franchise/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Machine List",
        url: APP_ROUTES.TECHNICIAN_VM_LIST,
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Franchise Overview",
          options.franchiseName
        ),
      },
    ],
    [APP_ROUTES.TECHNICIAN_LINK_NEW_VM]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Technician Partner List",
        url: APP_ROUTES.TECHNICIAN_PARTNER_LIST,
      },
      {
        title: "Technician Overview",
        url: `/technician-partner/${options.technicianId}`,
      },
      {
        title: "Link New Vending Machine",
      },
    ],
    [APP_ROUTES.TECHNICIAN_EDIT_LINK_VM]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Technician Partner List",
        url: APP_ROUTES.TECHNICIAN_PARTNER_LIST,
      },
      {
        title: "Technician Overview",
        url: `/technician-partner/${options.technicianId}`,
      },
      {
        title: "Edit Link Vending Machine",
      },
    ],
    [APP_ROUTES.TECHNICIAN_PARTNER_VIEW]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Technician Partner List",
        url: APP_ROUTES.TECHNICIAN_PARTNER_LIST,
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Technician Overview",
          options.technicianPartnerName
        ),
      },
    ],
    [APP_ROUTES.TECHNICIAN_PARTNER_EDIT]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Technician Partner List",
        url: APP_ROUTES.TECHNICIAN_PARTNER_LIST,
      },
      {
        title: appendNameToBreadcrumbTitle(
          "Technician Partner Edit",
          options.technicianPartnerName
        ),
      },
    ],
    [APP_ROUTES.TECHNICIAN_VIEW_VM]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Machine List",
        url: APP_ROUTES.TECHNICIAN_VM_LIST,
      },
      {
        title: appendNameToBreadcrumbTitle("VM Overview", options.vmName),
      },
    ],
    [APP_ROUTES.TECH_CREATE_VENDING_MACHINE]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Machine List",
        url: APP_ROUTES.TECHNICIAN_VM_LIST,
      },
      {
        title: "Create Vending Machine",
      },
    ],
    [APP_ROUTES.TECH_EDIT_VENDING_MACHINE]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Machine List",
        url: APP_ROUTES.TECHNICIAN_VM_LIST,
      },
      {
        title: options.vmName,
        url: `/technician-vm/${options.vmId}`,
      },
      {
        title: "Edit",
      },
    ],
    "/tech-vm-snapshot/:vmId": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Machine List",
        url: APP_ROUTES.TECHNICIAN_VM_LIST,
      },
      {
        title: options.vmName,

        url: `/technician-vm/${options.vmId}`,
      },
      {
        title: `Live stock`,
        // title: `Live stock (${options.vmName})`,
      },
    ],

     "/tech-deletedVm/:id": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
       {
        title: "Vending Machine List",
        url: APP_ROUTES.TECHNICIAN_VM_LIST,
      },
      {
        title: options.vmName,
      },
    ],

    "/tech-vm-snapshot/:vmId": [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Vending Machine Template List",
        url: APP_ROUTES.TECH_VM_TEMPLATE_LIST,
      },
      {
        title: options.vmName,

        url: `/technician-vm/${options.vmId}`,
      },
      {
        title: `Live stock`,
        // title: `Live stock (${options.vmName})`,
      },
    ],
    [APP_ROUTES.MACHINE_EVENT_LOG]: [
      {
        title: HomeTab(),
        url: "/dashboard",
      },
      {
        title: "Machine Communication Log",
      },
    ],
  };
  // Replaces Dashboard with Product List as first breadcrumb only for Product partners
  (function () {
    if (
      !visibleHomePage &&
      !routesReplaceDashboardWithProductList.includes(matchPath)
    ) {
      breadcrumbsData[matchPath][0] = {
        title: "Product List",
        url: APP_ROUTES.PRODUCT_CATALOG,
      };
    } else if (!visibleHomePage) {
      // delete dashboard title on first breadcrumb only for product catalog
      delete breadcrumbsData[matchPath][0];
    }
  })();
  return breadcrumbsData[matchPath];
};
